import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export enum CashRegisterStatus {
    Open = 'Open',
    Closed = 'Closed'
}
export interface CashRegister {
    id?: string;
    userId?: string;
    username?: string;
    branchOfficeId?: string;
    status: CashRegisterStatus;
    /** Apertura. Junto con `closedAt` define la ventana de la caja (ver @utils/CashRegisters) */
    date: any;
    initialCash: number;
    // ── Corte ciego (2026-08-17) ────────────────────────────────────────────────
    // Todos opcionales: las cajas cerradas antes de esto no los tienen y las
    // pantallas deben tolerarlo.
    /** Cierre. Sin esto no se puede repartir el dinero del día entre varias cajas */
    closedAt?: any;
    closedByUserId?: string;
    closedByName?: string;
    /** Lo que contó físicamente quien cerró, SIN ver el esperado */
    countedCash?: number;
    /** Lo que el sistema esperaba en ese momento (fondo + ventas efectivo + entradas − salidas − envíos) */
    expectedCash?: number;
    /** countedCash − expectedCash: negativo = faltante, positivo = sobrante */
    difference?: number;
    closingNote?: string;
}
export const CASH_REGISTERS_COLLECTION = 'cash-registers';
export const cashRegistersRef = collection(firestore, CASH_REGISTERS_COLLECTION);
